export function location(zone: string): string {
  return zone
    .replace(/^(0*)/g, '')
    .replace(/\.0*(\d)/g, '.$1');
}
